/* Equalize collection-card titles to the tallest in the grid (scoped to #product-grid only; capped at 4 lines via CSS clamp).
   CLS fix 30jul: only-grow — never reset min-height to 0 on visible grid (fonts.ready/mutations caused double reflow = layout shifts).
   Reset happens only on viewport resize, where reflow is expected. */
(function(){
  var maxSeen=0;
  function eq(){
    var grid=document.getElementById('product-grid');
    if(!grid)return;
    var ts=grid.querySelectorAll('.product-card-title');
    if(!ts.length)return;
    var i,max=0;
    for(i=0;i<ts.length;i++){var h=ts[i].offsetHeight;if(h>max)max=h;}
    if(max>maxSeen)maxSeen=max;
    if(maxSeen>0)for(i=0;i<ts.length;i++)ts[i].style.setProperty('min-height',maxSeen+'px','important');
  }
  function hardReset(){
    maxSeen=0;
    var grid=document.getElementById('product-grid');
    if(grid){var ts=grid.querySelectorAll('.product-card-title');for(var i=0;i<ts.length;i++)ts[i].style.setProperty('min-height','0','important');}
    eq();
  }
  if(document.readyState!=='loading')eq();else document.addEventListener('DOMContentLoaded',eq);
  window.addEventListener('load',eq);
  var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(hardReset,150);});
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(eq);
  var grid=document.getElementById('product-grid');
  if(grid&&window.MutationObserver)new MutationObserver(function(){clearTimeout(rt);rt=setTimeout(eq,120);}).observe(grid,{childList:true,subtree:true});
})();
